define("mobile/main", ["jquery", "app", "lazyload","jquerycookie"], function ($, app , lazyload,jquerycookie) {
    app.render_page("mobile");
});
require(['mobile/main']);
